import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon DashboardIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const DashboardIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        d="M1.2168 11.5088H9.33887C9.59518 11.5088 9.81918 11.7234 9.81934 12.0078V22.001C9.81933 22.2855 9.59527 22.5 9.33887 22.5H1.2168C0.960398 22.5 0.736331 22.2855 0.736328 22.001V12.0078C0.736483 11.7234 0.960485 11.5088 1.2168 11.5088ZM14.8096 16.4854H22.9326C23.1889 16.4855 23.413 16.7 23.4131 16.9844V21.8379C23.4131 22.1223 23.1889 22.3377 22.9326 22.3379H14.8096C14.5533 22.3377 14.3291 22.1224 14.3291 21.8379V16.9844C14.3292 16.7 14.5533 16.4855 14.8096 16.4854ZM14.8975 1.5H23.0195C23.2759 1.5 23.5 1.71447 23.5 1.99902V11.9922C23.4998 12.2766 23.2758 12.4912 23.0195 12.4912H14.8975C14.6411 12.4912 14.4171 12.2766 14.417 11.9922V1.99902C14.417 1.71447 14.6411 1.5 14.8975 1.5ZM0.980469 1.5H9.10254C9.35894 1.5 9.583 1.71447 9.58301 1.99902V6.85254C9.58301 7.1371 9.35894 7.35156 9.10254 7.35156H0.980469C0.724068 7.35156 0.5 7.1371 0.5 6.85254V1.99902C0.500003 1.71447 0.724069 1.5 0.980469 1.5Z"
        stroke="#503291"
      />
    </Icon>
  )
}
export default DashboardIcon
